/**
 * Product media modal – custom element that opens/closes the product media modal.
 * Match structure: <product-modal><div class="product-media-modal__dialog">...</div></product-modal>
 * Open: document.getElementById('ProductModal-{{ section.id }}').showModal()
 */
class ProductModal extends HTMLElement {
  constructor() {
    super();
    this._dialog = null;
    this._closeButton = null;
    this._boundClose = this.close.bind(this);
    this._boundKeyDown = this._handleKeyDown.bind(this);
    this._boundClick = this._handleClick.bind(this);
  }

  connectedCallback() {
    this._dialog = this.querySelector('.product-media-modal__dialog');
    this._closeButton = this.querySelector('[data-close-modal]');
    if (this._closeButton) {
      this._closeButton.addEventListener('click', this._boundClose);
    }
    document.addEventListener('keydown', this._boundKeyDown);
    this.addEventListener('click', this._boundClick);
  }

  disconnectedCallback() {
    if (this._closeButton) {
      this._closeButton.removeEventListener('click', this._boundClose);
    }
    document.removeEventListener('keydown', this._boundKeyDown);
    this.removeEventListener('click', this._boundClick);
  }

  _handleKeyDown(e) {
    if (e.key !== 'Escape' || !this.hasAttribute('open')) return;
    this.close();
  }

  _handleClick(e) {
    if (e.target !== this._dialog) return;
    this.close();
  }

  showModal() {
    this.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    if (this._closeButton) this._closeButton.focus();
  }

  close() {
    this.removeAttribute('open');
    document.body.style.overflow = '';
  }

  get open() {
    return this.hasAttribute('open');
  }
}

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModal);
}
